import FilterProcessor from './filterProcessor';

export default FilterProcessor.extend({
  addFilter(filter) {
    const model = this.filters.find((itr) => itr.get('field') === filter.field);

    if (filter.label) {
      if (model) {
        model.set(filter);
      } else {
        this.filters.add(filter);
      }
      this.trigger('add', filter, this.filters);
    }

    this.process();
  }
});
